<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_chart"] }] */
import { Line, mixins } from 'vue-chartjs';
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';
import {
  Classic20 as ColorScheme,
} from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau';
import moment from 'moment';

const { reactiveData } = mixins;

export default {
  extends: Line,
  mixins: [reactiveData],
  props: {
    chart: {
      type: Array[Object],
      default: () => [],
    },
    chartType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      datasets: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          colorschemes: {
            scheme: ColorScheme,
            reverse: process.env.NODE_ENV !== 'production',
          },
        },
        title: {
          display: true,
          text: this.chart.variable.name,
        },
        scales: {
          xAxes: [
            {
              type: 'time',
              time: {
                displayFormats: {
                  month: this.chartType === 'daily' ? 'MMM' : 'MMM YYYY',
                },
                unit: 'month',
                tooltipFormat: this.chartType === 'daily' ? 'DD MMM' : 'DD/MM/YYYY',
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: !!this.chart.variable.units,
                labelString: this.chart.variable.units || '',
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.updateChartData();
  },
  created() {
    moment.locale('es-ES');
  },
  methods: {
    updateChartData() {
      this.chartData = {
        datasets: this.chart.series.map((series) => {
          const serieLabel = series.plot.label || series.plot['ref-catastral'];
          return {
            label: this.chartType === 'daily'
              ? `${serieLabel} ${series.crop} (${series.year})`
              : `${serieLabel}`,
            fill: false,
            data: series.data,
            lineTension: 0,
            borderWidth: 1.5,
          };
        }).flat(),
      };
      console.log(this.chartData);
    },
  },
  watch: {
    chart() {
      this.updateChartData();
    },
  },
};

</script>

<style>
</style>
